<template>
  <AuthFailure>
    <template #textSlot>
      <h2 style='max-width:480px'>Ваша учетная запись не активна,<br />дождитесь модерации</h2>
    </template>
  </AuthFailure>
</template>

<script>
import AuthFailure from '../../components/auth-failure/AuthFailure.vue';
export default {
  name: 'BlockedUser',
  components: { AuthFailure },
  metaInfo() {
    return {
      title: `Пользователь не найден - ЛУКМАРКЕТ`,
    }
  },
}
</script>

<style></style>
